import React from 'react';
import './AuthCallback.css';

const AuthCallback = () => {
  return (
    <div className="auth-callback">
      <div className="auth-callback-content">
        <div className="spinner"></div>
        <p>Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;

